import {BaseFormModel} from '../base-form-model';

export class FilterValue extends BaseFormModel<FilterValue> {
    id: number;
    value: any;
}
